const RadioButton = ({
    options = [],
    selectedValue = '',
    onChange = () => {},
    name = 'radio-group',
    groupLabel = '',
    disabled = false,
    layout = 'vertical', // 'vertical', 'horizontal', 'grid'
    size = 'medium', // 'small', 'medium', 'large'
    color = '#3b82f6',
    className = ''
  }) => {
    const handleRadioChange = (value) => {
      if (disabled) return;
      onChange(value);
    };
  
    const sizeClasses = {
      small: 'radio-small',
      medium: 'radio-medium',
      large: 'radio-large'
    };
  
    const layoutClasses = {
      vertical: 'radio-vertical',
      horizontal: 'radio-horizontal',
      grid: 'radio-grid'
    };
  
    return (
      <>
        <style>{`
          .radio-container {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          }
  
          .radio-group-label {
            font-weight: 600;
            color: #374151;
            margin-bottom: 12px;
            font-size: 16px;
          }
  
          .radio-group-label.disabled {
            color: #9ca3af;
          }
  
          .radio-vertical {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }
  
          .radio-horizontal {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
          }
  
          .radio-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 12px;
          }
  
          .radio-item {
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: all 0.2s ease;
            padding: 8px;
            border-radius: 8px;
            position: relative;
          }
  
          .radio-item:hover:not(.disabled) {
            background: #f8fafc;
          }
  
          .radio-item.disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
  
          .radio-input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }
  
          .radio-custom {
            position: relative;
            border: 2px solid #d1d5db;
            border-radius: 50%;
            background: white;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
  
          .radio-small .radio-custom {
            width: 16px;
            height: 16px;
          }
  
          .radio-medium .radio-custom {
            width: 20px;
            height: 20px;
          }
  
          .radio-large .radio-custom {
            width: 24px;
            height: 24px;
          }
  
          .radio-custom:hover:not(.disabled) {
            border-color: var(--radio-color);
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }
  
          .radio-custom.checked {
            border-color: var(--radio-color);
          }
  
          .radio-custom.disabled {
            background: #f9fafb;
            border-color: #e5e7eb;
          }
  
          .radio-dot {
            border-radius: 50%;
            background: var(--radio-color);
            opacity: 0;
            transition: all 0.2s ease;
          }
  
          .radio-small .radio-dot {
            width: 8px;
            height: 8px;
          }
  
          .radio-medium .radio-dot {
            width: 10px;
            height: 10px;
          }
  
          .radio-large .radio-dot {
            width: 12px;
            height: 12px;
          }
  
          .radio-custom.checked .radio-dot {
            opacity: 1;
            transform: scale(1);
          }
  
          .radio-label {
            margin-left: 12px;
            color: #374151;
            transition: color 0.2s ease;
            flex: 1;
          }
  
          .radio-small .radio-label {
            font-size: 14px;
          }
  
          .radio-medium .radio-label {
            font-size: 16px;
          }
  
          .radio-large .radio-label {
            font-size: 18px;
          }
  
          .radio-label.disabled {
            color: #9ca3af;
          }
  
          @media (max-width: 768px) {
            .radio-horizontal {
              flex-direction: column;
            }
            
            .radio-grid {
              grid-template-columns: 1fr;
            }
          }
        `}</style>
  
        <div 
          className={`radio-container ${className}`}
          style={{ '--radio-color': color }}
        >
          {groupLabel && (
            <div className={`radio-group-label ${disabled ? 'disabled' : ''}`}>
              {groupLabel}
            </div>
          )}
          
          <div className={`${layoutClasses[layout]} ${sizeClasses[size]}`}>
            {options.map((option, index) => {
              const value = typeof option === 'string' ? option : option.value;
              const label = typeof option === 'string' ? option : option.label;
              const isDisabled = disabled || (typeof option === 'object' && option.disabled);
              const isSelected = selectedValue === value;
              
              return (
                <label
                  key={index}
                  className={`radio-item ${isDisabled ? 'disabled' : ''}`}
                >
                  <input
                    type="radio"
                    name={name}
                    className="radio-input"
                    checked={isSelected}
                    onChange={() => handleRadioChange(value)}
                    disabled={isDisabled}
                  />
                  <div className={`radio-custom ${isSelected ? 'checked' : ''} ${isDisabled ? 'disabled' : ''}`}>
                    <span className="radio-dot"></span>
                  </div>
                  <span className={`radio-label ${isDisabled ? 'disabled' : ''}`}>
                    {label}
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  export default RadioButton;